module.exports = __webpack_public_path__ + "img/26_139.09384374.png";